import { Country } from '@immosky/types';

const swissNumberFormatter = new Intl.NumberFormat('de-CH');
const frenchNumberFormatter = new Intl.NumberFormat('fr-FR');
const germanNumberFormatter = new Intl.NumberFormat('de-DE');

export function formatNumber(value: number, country?: Country): string {
  let formatter: Intl.NumberFormat;

  switch (country) {
    case 'FR':
      formatter = frenchNumberFormatter;
      break;
    case 'DE':
      formatter = germanNumberFormatter;
      break;
    case 'CH':
    default:
      formatter = swissNumberFormatter;
      break;
  }

  return formatter.format(value);
}
